(function() {
    'use strict';

    angular
        .module('app')
        .directive('cEditable', cEditable);

    cEditable.$inject = ['$window'];
    
    function cEditable($window) {
        // Usage:
        //     <contentEditable></contentEditable>
        // Creates:
        // 
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: link,
            scope: {
                editable: "=?",
                onBlur: "=?",
                editMode: "=?"
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            scope.$watch(function () {
                return scope.editable;
            }, function (value) {
                element[0].contentEditable = value;
                if (value) {
                    element[0].focus();
                }
                function read() {
                    ngModel.$setViewValue(element[0].textContent);
                }

                ngModel.$render = function () {
                    element.html(ngModel.$viewValue || "");
                };

                element.bind("blur keyup change", function () {
                    
                    scope.$apply(read);
                    
                });

                element.bind("blur", function () {
                    scope.editMode = false;
                    scope.editable = false;
                    scope.$apply();
                })
            });
        }
    }

})();